import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { dateFnsLocaleMap, Locale, localeMessagesMap, StringKey } from '../lang/index';

export const useLocale = () => {
  const { locale } = useIntl();

  // Only en.json is guaranteed to carry every StringKey — the other dictionaries trail it by
  // hundreds of keys, and `localeMessagesMap`'s Record type hides that. Merging over the English
  // map keeps a missing key rendering its English text instead of `undefined` — the same fallback
  // `getTranslation` applies.
  const messagesLocale = useMemo(
    () =>
      locale === Locale.EN
        ? localeMessagesMap[Locale.EN]
        : { ...localeMessagesMap[Locale.EN], ...localeMessagesMap[locale] },
    [locale],
  );

  return {
    locale,
    dateFnsLocale: dateFnsLocaleMap[locale],
    messagesLocale,
    messagesLocaleFn: (key: StringKey, values: Record<string, number | string> = {}) =>
      Object.entries(values).reduce<string>(
        (text, [key, value]) => text.replace(`{${key}}`, value.toString()),
        messagesLocale[key],
      ),
  };
};
